import { Button } from "../../components";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generalIcons } from "../../utils/constants";
import { copyToClipBoard, getTruncatedAddress } from "../../utils/helper";

export default function UserBulletin({ selectedValidator }) {
  const navigate = useNavigate();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  }, []);
  return (
    <div className="flex items-center justify-between gap-5 mt-5 lg:mt-[30px] flex-wrap laptop:flex-nowrap">
      <div className="flex flex-wrap lg:flex-nowrap gap-[10px]">
        <div className="px-3 py-[10px] bg-[#1A1A1A] rounded-lg flex items-center text-xsm text-white lg:text-sm font-medium">
          Contract Address
          <span className="ml-[10px] text-textcolor/50">
            {getTruncatedAddress(
              selectedValidator?.contract_address,
            )}
          </span>
          <span
            className="ml-4 lg:ml-[30px] text-white/50 cursor-pointer"
            onClick={() => {
              copyToClipBoard(
                selectedValidator?.contract_address,
              );
              setIsCopied(true)
            }}
          >
            {isCopied ?generalIcons.copied :generalIcons.copyAddress}
          </span>
        </div>
        {/* <div className="px-3 py-[10px] bg-[#1A1A1A] rounded-lg flex items-center text-xsm text-white lg:text-sm font-medium">
          Signer
          <span className="ml-[10px] text-textcolor/50">
            {getTruncatedAddress("0x83C130DAFF96D12Bdkjn43FfC7714407C5c6e9A86")}
          </span>
          <span className="ml-4 lg:ml-[30px] text-white/50 cursor-pointer">
            {generalIcons.copyAddress}
          </span>
        </div> */}
        {/* <div className="px-3 py-[10px] bg-[#50FDDB]/10 rounded-lg flex items-center text-xsm text-dim/75 lg:text-sm font-medium">
          Checkpoint Signed
          <span className="ml-[10px] text-green">
            {selectedValidator?.checkpoint_signed}
          </span>
        </div> */}
        <div className="px-3 py-[10px] bg-[#50FDDB]/10 rounded-lg flex items-center text-xsm text-dim/75 lg:text-sm font-medium">
          Commision
          <span className="ml-[10px] text-green">
            {selectedValidator?.commission}
          </span>
        </div>
      </div>

      <Button
        className={`primary-gradient py-4 md:py-5 px-7 leading-none ${selectedValidator?.commission === "100%" ? "!opacity-50 !cursor-not-allowed" : ""}`}
        onClick={() => navigate("/delegate")}
        disabled={selectedValidator?.commission === "100%"}
      >
        Delegate
      </Button>
    </div>
  );
}
